import { render } from "./Home.vue?vue&type=template&id=b8853504"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b8853504&lang=scss"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge.PrimeraEntrevista\\PircaSolutions.Forge.PrimeraEntrevista.UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__